import { ReactElement, ReactNode } from 'react';

import cn from 'classnames';

import styles from './styles.module.scss';

type Sizes = {
  lg?: number; // max
  md?: number; // 1280px
  sm?: number; // 960px
};

interface ItemContainerProps extends Sizes {
  children: ReactNode;
}

export function GridItem({
  children,
  lg,
  md,
  sm,
}: ItemContainerProps): ReactElement {
  return (
    <div
      className={cn({
        [styles[`lg-${lg}`]]: lg,
        [styles[`md-${md}`]]: md,
        [styles[`sm-${sm}`]]: sm,
      })}
    >
      {children}
    </div>
  );
}
